import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import type { TypedUseSelectorHook } from "react-redux";
import type { RootState, AppDispatch } from "../redux/store";
import { useInView } from "react-intersection-observer";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const formatDate = (dateString: any) => {
  const options: Intl.DateTimeFormatOptions = { year: "numeric", month: "long", day: "numeric" };
  return new Date(dateString).toLocaleDateString("fr-FR", options);
};

export const RIBDisplay = (rib: string) => {
  const firstFour = rib.slice(0, 4);
  const lastFour = rib.slice(-4);
  const maskedPart = "*".repeat(rib.length - 8);
  const newRIB = `${firstFour}${maskedPart}${lastFour}`;

  return newRIB;
};

export const useScrollToHash = (targetHash: string, targetId: string) => {
  useEffect(() => {
    if (window.location.hash === targetHash) {
      const targetSection = document.getElementById(targetId);
      if (targetSection) {
        targetSection.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [targetHash, targetId]);
};

export const useScrollToTop = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  });
};

export const useDebounce = (value: string, delay: number) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => clearTimeout(handler);
  }, [value, delay]);
  return debouncedValue;
};

export const useSingleInView = () => {
  return useInView({
    triggerOnce: true,
    threshold: 0.1,
  });
};
